import Vue from 'vue';
import Page from '@views/posts';

new Vue({
	el: '#vue-post',
	render: (h) => h(Page),
});



// WEBPACK FOOTER //
// ./src/js/posts.js